import { BasicSelect, MultiSelect } from 'vue-search-select';
import CryptoJS from 'crypto-js';
import Pagination from './../../../../shared/components/pagination';
import CustomExpandableTable from '../../../../shared/components/customExpandableTable';
import Loader from '../../../../shared/components/loader';
import Treeselect from '@riophae/vue-treeselect';
import createFtcRadShipment from './../createFtcRadShipment';
import TripServices from './../../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import CONSTANT from './../../../../shared/constants/constant'
import FTCMemoDepositSlip from './../FTCMemoDepositSlip';
import Printd from 'printd'
import moment from 'moment';
import Multiselect from 'vue-multiselect'

export default {
  name: 'FTCRADShipmentList',
  components: {
    Treeselect,
    CryptoJS,
    Pagination,
    BasicSelect,
    CustomExpandableTable,
    Loader,
    TripServices,
    FTCMemoDepositSlip,
    createFtcRadShipment,
    Multiselect

  },
  data: function () {
    return {
      createFtcRadShipment: false,
      isLoading: false,
      companyNamelist: [],
      tableColumn: ['AWB', 'MPS Co', 'Client Name', 'Consignee Name', 'Consignee Address', 'RAD Date', 'Cash Memo Generate','Payment Status', 'Actions'],
      tableItems: [],
      CashMemo: "",
      totalPage: 0,
      currentPage: 1,
      total: 0,
      totalCount: 0,
      perPage: 0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      offset: 0,
      radToDate: "",
      radFromDate: "",
      parentObj: {},
      companyName: null,
      AWB: "",
      printAwb:[],
      showPrintCashMemo:false,
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.defaulthubid = userdetail.hubID[0];
    this.getCompanyShortName();
    this.GetFTCShipmentListing();
  },
  methods: {
    async GetFTCShipmentListing(){
      try {
        this.isLoading = true;
        this.tableItems = []
        let inputPayload = {
          "offset": this.currentPage || 1,
          "limit": this.pageLimit,
          "hubid":this.defaulthubid, //for testing use 24
        }
        if(this.AWB){
          inputPayload.awb = this.AWB;
        }
        if(this.companyName){
          inputPayload.clientname = this.companyName.id;
        }
        if(this.radFromDate){
          inputPayload.raddatefrom = this.radFromDate;
        }
        if(this.radToDate){
          inputPayload.raddateto = this.radToDate;
        }
        if(this.CashMemo) {
          inputPayload.cashmemogenerated = this.CashMemo == 'Yes' ? true : false;
        }
        let result = await TripServices.GetFTCListing(inputPayload)
        if(result.data.code == 200){
          this.totalCount = result.data.data.data.TotalCount?Number(result.data.data.data.TotalCount):0;
          this.tableItems = result.data.data.data.Result.map((el)=>{
            return {
              'id': el.AWB,
              "AWB": el.AWB,
              "MPS Co": el.MPSCount,
              "Client Name": el.ClientName,
              "Consignee Name": el.ConsigneeName,
              "Consignee Address": el.ConsigneeAddress,
              "RAD Date": moment(el.RADDate).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm:ss'),
              "Cash Memo Generate": el.CashMemoGenereted == true ? "Yes" : "No",
              "Payment Status" : el.paid == 1 ? "Paid" : "Unpaid",
              "label" : el.ftcrecalculateflag == 1 ? "Recalculate FTC" : "Calculate FTC",
              'Actions': 'click OnEvent',
              'iscompletebooking' : el.iscompletebooking == 1?true:false,
              'FTCRecordsTableFlag' : true
            }
          })
          // this.reset()
        }else{
          this.totalCount = 0
          this.tableItems = [];
        }
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    searchFTCListing(){
      this.currentPage = 1;
      this.offset = 0;
      this.GetFTCShipmentListing();
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.GetFTCShipmentListing();
    },
    reset () {
      this.currentPage = 1
      this.offset = 0;
      this.AWB = "",
      this.companyName = null,
      this.radFromDate = "",
      this.radToDate = "",
      this.CashMemo = "",
      this.onPageChange(1)
      this.GetFTCShipmentListing()
    },
    async getCompanyShortName() {
      try {
        var CompanyShortList = [];
        let result = await TripServices.getActiveInactiveClientList()
        CompanyShortList = result.data.data;
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.companyNamelist.push({
            'id': CompanyShortList[i].ClientMasterID,
            'label': CompanyShortList[i].CompanyName  ,
            'CompanyName': CompanyShortList[i].ClientMasterID
          })
        }
      } catch (err) {
        console.log(err);
      }
    },
    callParent() {
      this.GetFTCShipmentListing();
      this.createFtcRadShipment = false;
    },
    showCreateFTCShipment() {
      this.createFtcRadShipment = true;
    },
    getCustomTableEvent(id) {
      if (id.actionType == 'calculateFtc') {
        this.parentObj.AWB = id.id;
        this.parentObj.action = id.actionType;
        this.createFtcRadShipment = true;
      }
       if(id.actionType == 'cashMemo'){
         this.parentObj.AWB = id.id;
         this.parentObj.action = id.actionType;
         // this.createFtcRadShipment = true;
          this.clickPrintCashMemo();
       }
    },
    async clickPrintCashMemo() {
      this.isLoading = true;
      await this.setMulipleAwbData(this.parentObj.AWB)
      this.showPrintCashMemo = true;
      this.isLoading = false;
    },
    async setMulipleAwbData(){
      this.printAwb=[]
        let data = await this.GetCashMemoData()
        if(data.data.code == 200){
        this.printAwb.push(data.data.data)
        }else{
          this.$alert(item.AWB + " - " + data.data.message,"", "error");
        }
    },
    async GetCashMemoData(){
      let payload = {
        // 'awb':"9418522190201"
        awb:this.parentObj.AWB,
      }
      let data = await TripServices.GetCashMemoData(payload)
      return data
    },
    async printCashMemo(){
      try {
        if (this.printAwb.length < 1) {
          this.isLoading = false
          return
        }
      const d = new Printd();
      var buffer = '';

      var cssText = `
           body{
               -webkit-print-color-adjust:exact;
               font-family: Roboto,sans-serif;
               font-size:20%;
           }
           hr {
                margin-top: 1rem;
                margin-bottom: 1rem;
                border: 1;
                border-top: 1px solid #000;
            }
           table {
               border-collapse: collapse;
               margin-left:3px !important;
           }
           table, td, th {
             border-style: solid;
             border-width: 1px;
             padding:5px;
           }
           .text-right{
             text-align:right;
           }
           .text-left{
             text-align:left;
           }
           .text-center{
             text-align:center;
           }
           .h3-center-text{
             text-align:center;
           }
           @media print {
           .text-primary th{
             background-color:rgb(226, 216, 216) !important;
             color:black !important;
             font-size:20px !important;
           }
          }
          @media print {
          .pagebreak {
          page-break-after: always;
          }
          }
          `
          this.$nextTick(() => {
            d.print(document.getElementById('printCashMemoData'), cssText);
          })
    } catch (error) {
      this.isLoading=false
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/FtcRadShipment/FtcRadShipmentListing/FtcRadShipmentListing.component.js